import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'lib-bo-auth-card',
  standalone: true,
  templateUrl: './bo-auth-card.component.html',
  styleUrls: ['./bo-auth-card.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoAuthCardComponent {
  readonly title = input.required<string>();
  readonly subtitle = input('');
}
